import React, { memo, useEffect } from 'react'
import { CallBackModel, HistoryCities } from '../interfaces'
import styles from '../index.less'
import classnames from 'classnames';
import { PartOperation } from '../interfaces/enums';
import { getCookie, TLang } from '@/utils/lang';
// import getCookie from '@/components/selectCityPart/components/getCookie'
interface PropTypes {
  /** 历史访问城市数据 */
  historyCities: HistoryCities[]
  /** 事件回调 */
  callBack?: (args: CallBackModel<HistoryCities>) => any
}

function HistoryCitiesPart(props: PropTypes) {
  const { historyCities, callBack } = props;

  const clickCity = (item, cid?: number) => {
    let obj: CallBackModel<HistoryCities> = {
      data: item,
      type: PartOperation.selectedCity
    };
    callBack && callBack(obj)
  }

  return (
    <div className={styles.current_city}>
      <h3>{TLang("最近访问城市",'home',false,false,null)}</h3>
      <ul>
        {
          historyCities
          && historyCities.length > 0
          && historyCities.map((item, index) => (
            <li
              key={index}
              onClick={() => clickCity(item)}
              className={classnames({ li3: (index + 1) % 3 === 0 })}
            >
             {getCookie('df_lang')==='en-US'?item.pinyin:item.name}
            </li>
          ))
        }
      </ul>
    </div>
  )
}
export default memo(HistoryCitiesPart)
